<!--
 * @Description: 脚部通用组件
 * @Author: youme
 * @LastEditors: YTH
 * @Date: 2020-06-12 08:58:39
 * @LastEditTime: 2024-12-12 13:50:16
-->
<template>
  <div>
    <div class="hidden-md-and-down" style="height: 492px">
      <div class="suspension-body">
        <!-- <div class="online-service" @click="showAnswerQuestion = true">
          <img width="20" src="../assets/suspension/onlineService.png" alt="online-service">
          智能客服
        </div> -->
        <div class="wechat-info">
          <img width="26" src="../assets/suspension/wechatInformation.png" alt="wechat-information">
          微信咨询
          <div class="wechat-code" />
        </div>
        <div class="aftersales-service">
          <img width="22" src="../assets/suspension/aftersalesService.png" alt="aftersales-service">
          售后服务
          <div class="service-phone">
            <div>15754006667</div>
            <div>0411-39516676</div>
          </div>
        </div>
        <div class="back-top" @click="handleBackTop">
          <img width="16" src="../assets/suspension/backTop.png" alt="back-top">
          回到顶部
        </div>
      </div>
      <div class="container knee">
        <div>
          <div class="show-logo">
            <img :src="logo" alt="logo" class="image-logo">
            <div class="show-qrcode">
              <img class="qr-code qr-height" :src="qrCode" alt="qr-code">
              <img class="dy-code" :src="dy" alt="dy">
            </div>
            <div class="show-text">
              <div class="text-one">豪森智源公众号</div>
              <div class="text-two">豪森智源抖音号</div>
            </div>
            <div class="cmmi">
              <div class="cmmi-5" />
            </div>
            <div class="other-logo">
              <a href="https://baijiahao.baidu.com/u?app_id=1686311554126655">
                <img :src="baidu" alt="baidu">
              </a>
              <a href="https://www.zhihu.com/org/da-lian-hao-sen-zhi-yuan-shu-ju-you-xian-gong-si">
                <img :src="zhihu" alt="zhihu">
              </a>
              <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAA1WowqzltFJ19BuALUSWML2oLhO3tZsviCmRXUwAQqodBhusGDENL_Tjurt_yCzCb/?">
                <img :src="toutiao" alt="toutiao">
              </a>
              <a href="https://mp.sohu.com/profile?xpt=YjE3OTliNjYtN2UwZi00NDkwLThiNDgtNmU4ZDI1OTM5NGQy&_f=index_pagemp_1&spm=smpc.content.author.1.1714012832070kSj2Ssj">
                <img :src="souhu" alt="souhu">
              </a>
              <a href="https://www.ruanfujia.com/vendor/4434616/">
                <img :src="ruanfuzhijia" alt="ruanfuzhijia">
              </a>
              <a href="https://blog.csdn.net/hszy123456">
                <img :src="CSDN" alt="CSDN">
              </a>
            </div>
          </div>
        </div>
        <div class="right-part">
          <div class="link-items">
            <div>
              <div class="link-title">首次接触豪森智源MES?</div>
              <div class="link-normal" @click="handleJumpByUrl('/product-mes')">为什么选择豪森智源MES?</div>
              <div class="link-normal" @click="handleJumpByUrl('/product-mes')">什么是MES?</div>
              <div class="link-normal" @click="handleJumpByUrl('/companyvalue')">我们能为客户带来什么?</div>
            </div>
            <div>
              <div class="link-title">关于智源</div>
              <div class="link-normal" @click="handleJumpByUrl('/company-news')">智源资讯</div>
              <div class="link-normal" @click="handleJumpByUrl('/company-honor')">智源荣誉</div>
              <div class="link-normal" @click="handleJumpByUrl('/recruit')">加入我们</div>
              <div class="link-normal" @click="handleJumpByUrl('/lawstatement')">法律</div>
            </div>
            <div>
              <div class="link-title">友情链接</div>
              <div class="link-normal" @click="handleOpen('http://www.haosen.com.cn/')">豪森智能</div>
              <div class="link-normal" @click="handleOpen('http://www.haosen-soft.com/')">豪森软件</div>
            </div>
          </div>
          <div class="info-items">
            <div class="div">
              <div class="link-special">联系我们</div>
              <div class="contactus">
                销售热线：15754006669/0411-39516699
              </div>
              <div class="contactus" style="margin-top: 11px">
                售后服务：15754006667/0411-39516676
              </div>
            </div>
            <div class="div">
              <div class="link-special">让数据为客户创造价值</div>
              <div class="contactus">
                客户至上 追求完美 合作共赢
              </div>
            </div>
            <div class="div" />
          </div>
          <div class="copyright">©大连豪森智源数据有限公司 <a class="icon-emblem" target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=21021102001445">辽公网安备21021102001445号</a><a target="_blank" href="http://beian.miit.gov.cn/">辽ICP备18010847号-2</a> <span class="websitemap-link" @click="handleJumpByUrl('/website-map')">网站地图</span></div>
        </div>
      </div>
      <div v-if="showAnswerQuestion" class="online-service-body">
        <div class="service-title">
          <div class="icon-service" />
          <div class="title-text">智能客服</div>
          <i class="el-icon-close" @click="showAnswerQuestion = false" />
        </div>
        <div class="usual-question">
          <div @click="getAnswer('公司介绍')">公司介绍</div>
          <div @click="getAnswer('产品概述')">产品概述</div>
          <div @click="getAnswer('客户案例')">客户案例</div>
        </div>
        <div ref="answerBody" class="answer-show">
          <div
            v-for="item in history"
            :key="item.id"
            :class="{
              question: item.role === 'user',
              answer: item.role === 'assistant'
            }"
          > {{ item.content }}</div>
        </div>
        <div class="question-show">
          <textarea
            v-model="selectValue"
            class="question-input"
            placeholder="嗨，我是小智，您可以输入想问的问题，我会尽快为您解答~"
          />
          <div class="query-button" :class="{disable: answering}" @click="handleQuery" />
        </div>
      </div>
    </div>
    <div class="foot-down hidden-lg-and-up">
      <div class="container">
        <Button @click="callPhone">电话咨询</Button>
        <Button class="weixin-contact">
          微信咨询
          <div class="wechat-wrapper">
            <div class="wechat-code" />
            <div class="wechat-contact-text">
              长按保存二维码，与数字化转型顾问直接对话
            </div>
          </div>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/home/bottomLogo.png'
import address from '@/assets/home/address.png'
import phone from '@/assets/home/phone.png'
import cmmi from '@/assets/home/cmmi.png'
import qrCode from '@/assets/home/QRcode.jpeg'
import dy from '@/assets/home/dy.png'
import zhihu from '@/assets/home/zhihu.png'
import baidu from '@/assets/home/baidu.png'
import toutiao from '@/assets/home/toutiao.png'
import souhu from '@/assets/home/sohu.png'
import CSDN from '@/assets/home/CSDN.png'
import ruanfuzhijia from '@/assets/home/ruanfuzhijia.png'
import { Button, Message } from 'element-ui'
import { saveFeedback } from '../api'
import { fetchEventSource } from '@microsoft/fetch-event-source'

const cubic = value => Math.pow(value, 3)
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2

export default {
  name: 'Foot',
  components: { Button },
  data: function() {
    return {
      history: [],
      answering: false,
      selectValue: '',
      showAnswerQuestion: false,
      logo,
      address,
      phone,
      qrCode,
      dy,
      zhihu,
      baidu,
      CSDN,
      souhu,
      toutiao,
      ruanfuzhijia,
      cmmi,
      showFeedback: false,
      form: {},
      rules: {
        backType: [
          { required: true, message: '请选择反馈类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '请输入正确的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'change' },
          { pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '请输入正确的电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        advice: [
          { required: true, message: '请输入意见与建议', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleShowFeedback(val) {
      this.showFeedback = val
    },
    handleJumpByUrl(url) {
      this.$router.push({ path: url })
    },
    callPhone() {
      window.location.href = 'tel://15754006669'
    },
    handleOpen(url) {
      window.location.href = url
    },
    mailsome() {
      var who = 'haosenzhiyuan@haosen.com.cn'
      var what = '简历'
      parent.location.href = 'mailto:' + who + '?subject=' + what + ''
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveFeedback({ ...this.form }).then(_ => {
            Message({
              showClose: true,
              message: '反馈成功',
              type: 'success'
            })
            this.handleShowFeedback(false)
          })
        } else {
          return false
        }
      })
    },
    handleBackTop() {
      const el = document.documentElement
      const beginTime = Date.now()
      const beginValue = el.scrollTop
      const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
      const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
          rAF(frameFunc)
        } else {
          el.scrollTop = 0
        }
      }
      rAF(frameFunc)
    },
    handleQuery() {
      this.getAnswer(this.selectValue)
    },
    getAnswer(query) {
      if (this.answering) {
        return
      }
      this.answering = true
      fetchEventSource('/ai/easy_chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query,
          'knowledge_base_name': 'q',
          'top_k': 3,
          'score_threshold': 1,
          'history': this.history,
          'stream': true,
          'model_name': 'chatglm3-6b',
          'temperature': 0.7,
          'max_tokens': 0,
          'prompt_name': 'default'
        }),
        onopen: () => {
          this.selectValue = ''
          this.history.push({
            id: new Date().getTime(),
            'role': 'user',
            'content': query
          }, {
            id: new Date().getTime() + 1,
            'role': 'assistant',
            'content': ''
          })
        },
        onmessage: (ev) => {
          const { data } = ev
          const result = JSON.parse(data)
          const length = this.history.length
          if (result.answer) {
            this.history[length - 1].content += result.answer
            this.$refs.answerBody.scrollTop = this.$refs.answerBody.scrollHeight
          }
        },
        onclose: () => {
          this.answering = false
        },
        onerror(error) {
          this.answering = false
          throw error
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.suspension-body {
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 100;
  transform: translateY(-50%);

  & > div {
    color: #fff;
    height: 70px;
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background-color: #3d3491;
    border-bottom: 1px solid #645da7;
    border-left: 1px solid #645da7;

    &:hover {
      background-color: #645da7;
    }

    &.online-service {
      border-top: 1px solid #645da7;
      cursor: pointer;
      border-radius: 10px 10px 0 0;
    }

    &.wechat-info {
      border-radius: 10px 10px 0 0;
      position: relative;

      &:hover {
        .wechat-code {
          display: block;
        }
      }

      .wechat-code {
        display: none;
        position: absolute;
        width: 180px;
        height: 180px;
        background-color: #3d3491;
        border-radius: 10px;
        right: 115px;
        background-image: url('../assets/suspension/wechatInCode.jpg');
        background-repeat: no-repeat;
        background-position: center;

        &::after {
          content: '';
          position: absolute;
          height: 14px;
          width: 14px;
          background-color: #3d3491;
          right: -6px;
          top: 50%;
          transform: translateY(-50%) rotateZ(45deg);
        }
      }
    }

    &.aftersales-service {
      position: relative;

      &:hover {
        .service-phone {
          display: block;
        }
      }

      .service-phone {
        display: none;
        position: absolute;
        background-color: #3d3491;
        border-radius: 10px;
        right: 115px;
        width: 140px;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        padding: 20px;

        &::after {
          content: '';
          position: absolute;
          height: 14px;
          width: 14px;
          background-color: #3d3491;
          right: -6px;
          top: 50%;
          transform: translateY(-50%) rotateZ(45deg);
        }
      }
    }

     &.back-top {
      cursor: pointer;
      border-radius: 0 0 10px 10px;
    }

    img {
      margin-bottom: 10px;
    }
  }
}
.knee {
  box-sizing: border-box;
  padding-top: 28px;
  padding-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3e3892;
  width: 100%;
  height: 492px;
  .show-logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .show-qrcode{
      margin-top: 24px;
      display:flex;
      align-items:center;
      .qr-code{
        width: 130px;
        height:130px;
      }
      .dy-code {
        width: 140px;
        height:140px;
        margin-left:25px;
      }
    }
    .show-text {
      margin-top: 4px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      color: #fff;
      .text-one {
        width: 130px;
        text-align: center;
      }
      .text-two {
        margin-left: 25px;
        width: 140px;
        text-align: center;
      }
    }
    .other-logo {
      margin-top: 29px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      & > a:not(:last-of-type) {
        margin-right: 11px;
      }
    }
  }
  .cmmi {
    cursor: pointer;
    margin-top: 28px;
    .cmmi-5 {
      background-image: url('../assets/home/cmmi5.png');
      width: 218px;
      height: 78px;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .code-items {
    display: flex;
    margin-top: 80px;
    .public {
      width: 36px;
      height: 36px;
      background: url(../assets/home/public.png) no-repeat,
    }
    .wx {
      position: relative;
      width: 36px;
      height: 36px;
      margin-left: 24px;
      background: url(../assets/home/wx.png) no-repeat;
      &:hover {
        .wx-code {
          display: block;
        }
      }
      .wx-code {
        display: none;
        position: absolute;
        width: 150px;
        height: 150px;
        top: -83px;
        right: -156px;
        background: url(../assets/home/QRcode.jpeg) no-repeat;
        background-size: cover;
      }
    }
  }
  .right-part {
    margin-left: 218px;
    .link-items {
      width: 592px;
      display: flex;
      justify-content: space-between;
      color: #fff;
      .link-title {
        @include normalText;
        line-height: 17px;
        margin-bottom: 32px;
        color: #fff;
      }
      .link-normal {
        @include normalText;
        color: #fff;
        line-height: 17px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
    .info-items {
      margin-top: 40px;
      width: 592px;
      display: flex;
      justify-content: space-between;
      color: #fff;
      .link-special {
        @include secondTitle;
        font-size: 22px;
        color: #fff;
        padding-bottom: 12px
      }
      .contactus{
        display:flex;
        align-items: center;
      }
    }
    .copyright {
      margin-top: 28px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #fff;
      a {
        &.icon-emblem {
          position: relative;
          margin-left: 55px;
          &::before {
            position: absolute;
            left: -25px;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            height: 20px;
            width: 20px;
            background-image: url('../assets/nationalEmblem.png');
          }
        }
        color: #fff;
        text-decoration: none;
        margin-left: 20px;
        &:hover {
          text-decoration: underline;
        }
      }
      .websitemap-link {
        margin-left: 20px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.foot {
  width: 100%;
  background-color: #3e3892;
  .container {
    height: 94px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .foot-text {
    @include normalText;
    color: #fff;
    .text-up {
      display: flex;
      cursor: pointer;
      div {
        margin-right: 30px;
      }
    }
  }
  .feedback {
    position: fixed;
    bottom: 0;
    right: 152px;
    z-index: 104;
    color: #fff;
    width: 78px;
    height: 35px;
    font-size: 14px;
    background-color: #524bbe;
    border-radius: 4px 4px 0 0;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
  }
  .relation {
    position: fixed;
    bottom: 0;
    right: 40px;
    z-index: 104;
    color: #fff;
    font-size: 14px;
    width: 106px;
    height: 35px;
    background-color: #524bbe;
    border-radius: 4px 4px 0 0;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
  }
}
.foot-down {
  height: 70px;
	background-color: #524bbe;
}
@media screen and (max-width: 1200px) {
  .foot-down {
    height: 70px;
    background-color: #524bbe;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2000;
    .container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 100%;
      /deep/ .el-button {
        width: 155px;
        height: 44px;
        font-size: 14px;
        font-weight: 400;
        color: #3e3892;
        border-radius: 5px;
      }
      .weixin-contact {
        &:hover {
          .wechat-wrapper {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
        }
        .wechat-wrapper {
          position: absolute;
          bottom: 72px;
          right: 20px;
          display: none;
          width: 155px;
          height: 189px;
          padding: 14px;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0px 2px 8px 0px rgba(20, 15, 84, 0.22);
          border-radius: 5px;
          color: #666;
          .wechat-code {
            width: 128px;
            height: 127px;
            background-image: url('../assets/home/foot-qrcode.jpg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .wechat-contact-text {
            margin-top: 10px;
            width: 120px;
            height: 26px;
            font-size: 10px;
            line-height: 15px;
            white-space: normal;
            text-align: left;
          }
          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            height: 14px;
            width: 14px;
            background-color: #fff;
            transform: translate(-50%, -50%) rotateZ(45deg);
          }
        }
      }
    }
  }
}
.feedback-mask {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
}
.feedback-form {
  position: fixed;
  bottom: 0;
  right: 150px;
  width: 480px;
  background-color: #fff;
  z-index: 999;
  border-radius: 4px;
  overflow: hidden;
  .el-icon-close {
    position: absolute;
    right: 10px;
    top: 18px;
    font-size: 24px;
    color: #fff;
  }
  .form-title {
    height: 59px;
    background-color: #3e3892;
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 59px;
  }
  .form-describe {
    @include normalText;
    padding: 10px 20px;
    color: #222;
    line-height: 24px;
    background-color: #f4f4f4;
    border-bottom: 1px solid #ababab;
  }
  .form-body {
    padding: 20px;
    .item-label {
      font-size: 18px;
      color: #222;
      padding-bottom: 10px;
    }
  }
}

.online-service-body {
  position: fixed;
  width: 342px;
  height: 100vh;
  right: 0;
  top: 0;
  background-color: #ebeaf4;
  box-shadow: -10px 0px 28px 0px
    rgba(24, 43, 78, 0.1);
  z-index: 999;
  display: flex;
  flex-direction: column;

  .service-title {
    display: flex;
    margin: 27px 16px;
    align-items: center;

    .icon-service {
      height: 36px;
      width: 36px;
      border: 1px solid #a5a1cc;
      background-color: #fff;
      border-radius: 18px;
      margin-right: 12px;
      background-image: url('../assets/suspension/serviceIcon.png');
      background-repeat: no-repeat;
      background-position: center;
    }

    .title-text {
      font-size: 26px;
      color: #182b4e;
    }

    .el-icon-close {
      margin-left: auto;
      font-size: 30px;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .usual-question {
    div {
      position: relative;
      height: 48px;
      margin: 0 16px 12px;
      background-color: #fff;
      border-radius: 10px;
      border: solid 1px #dfe1e5;
      padding-left: 11px;
      line-height: 48px;
      color: #333;
      font-size: 14px;
      cursor: pointer;

      &::before {
        position: absolute;
        right: 20px;
        content: '';
        height: 7px;
        width: 7px;
        border-top: 2px solid #182b4e;
        border-right: 2px solid #182b4e;
        transform: translateY(-50%) rotateZ(45deg);
        top: 50%;
      }
    }
  }

  .answer-show {
    margin-top: 12px;
    height: 0;
    flex-grow: 1;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .question {
      background-color: #3d3490;
      border-radius: 10px;
      padding: 16px 10px;
      color: #fff;
      font-size: 14px;
      line-height: 20px;
      width: fit-content;
      margin-left: auto;
      margin-bottom: 20px;
      white-space: break-spaces;
    }

    .answer {
      border: solid 1px #dfe1e5;
      border-radius: 10px;
      padding: 16px 10px;
      background-color: #ffffff;
      font-size: 14px;
      line-height: 20px;
      color: #333;
      margin-bottom: 20px;
      width: fit-content;
      white-space: break-spaces;
    }
  }

  .question-show {
    margin: 24px 16px 36px;
    border: 1px solid #3d3491;
    background-color: #fafbfc;
    border-radius: 16px;
    height: 107px;
    display: flex;
    flex-direction: column;
    position: relative;

    .question-input {
      border: 0;
      background-color: transparent;
      resize: none;
      outline: none;
      margin: 12px;
      font-size: 14px;
      line-height: 20px;
    }

    .query-button {
      height: 26px;
      width: 36px;
      background-color: #3d3491;
      border-radius: 8px;
      position: absolute;
      bottom: 10px;
      right: 15px;
      background-image: url('../assets/suspension/aeroplane.png');
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;

      &.disable {
        pointer-events: none;
      }

      &:hover {
        background-color: #6560a8;
      }

      &:active {
        background-color: #383283;
      }
    }
  }
}
</style>

